import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {Party} from 'parties/PartyConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import * as Colors from 'ui-library/Colors';
import {EntityInputWithSearch} from 'ui-library/entity-input/EntityInputWithSearch';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

interface Props {
  assignee: Party | null;
  onChange: (party: Party | null) => void;
  alternateAssigneesOption?: {label: string; selected: boolean; setSelected: (selected: boolean) => void};
}

export default function AssigneeFormGroup(props: Props): JSX.Element {
  const inputComponent = (
    <EntityInputWithSearch
      allowOrganizations={false}
      allowTeams={true}
      onChange={(entities: Array<Party>) => {
        const [entity] = entities;
        props.onChange(entity);
      }}
      shouldAllowMultiple={false}
      size={TagsInputSize.MEDIUM}
      value={props.assignee ? [{id: props.assignee.id, handle: props.assignee.handle}] : []}
      disabled={props.alternateAssigneesOption != null && props.alternateAssigneesOption.selected}
    />
  );
  return (
    <FormGroup>
      <Label required={true} className={css(styles.assigneeLabel)}>
        Assignee
      </Label>
      {props.alternateAssigneesOption != null ? (
        <>
          <div>
            <label className="u-normal-font-weight">
              <input
                type="radio"
                checked={props.alternateAssigneesOption.selected}
                onChange={() => {
                  props.alternateAssigneesOption!.setSelected(true);
                }}
                className={css(styles.radioInput)}
              />
              <span className="u-tiny-spacing-left">{props.alternateAssigneesOption.label}</span>
            </label>
          </div>
          <div className="u-normal-font-weight u-flex-display u-vertical-flex">
            <label className="u-normal-font-weight">
              <input
                type="radio"
                checked={!props.alternateAssigneesOption.selected}
                onChange={() => {
                  props.alternateAssigneesOption!.setSelected(false);
                }}
                className={css(styles.radioInput)}
              />
              <span className="u-tiny-spacing-left">User or team</span>
            </label>
            {!props.alternateAssigneesOption.selected && <div className="u-flex-grow">{inputComponent}</div>}
          </div>
        </>
      ) : (
        inputComponent
      )}
    </FormGroup>
  );
}

const styles = StyleSheet.create({
  assigneeLabel: {
    ':after': {
      color: Colors.RED,
    },
  },
  radioInput: {
    marginTop: '2px',
    verticalAlign: 'top',
  },
});
